import Component from "@ember/component";
import { service } from "@ember/service";
import $ from "jquery";
import LoadMore from "discourse/mixins/load-more";
import { observes, on } from "discourse-common/utils/decorators";
export default Component.extend(LoadMore, dt7948.p({
  classNames: ["contents"],
  eyelineSelector: ".topic-list-item",
  documentTitle: service(),
  _monitorTrackingState() {
    this.stateChangeCallbackId = this.topicTrackingState.onStateChange(() => this._updateTrackingTopics());
  },
  _removeTrackingStateChangeMonitor() {
    if (this.stateChangeCallbackId) {
      this.topicTrackingState.offStateChange(this.stateChangeCallbackId);
    }
  },
  _updateTrackingTopics() {
    this.topicTrackingState.updateTopics(this.model.topics);
  },
  _updateTitle() {
    this.documentTitle.updateContextCount(this.incomingCount);
  },
  actions: {
    loadMore() {
      var _this = this;
      this.documentTitle.updateContextCount(0);
      this.model.loadMore().then(function () {
        let {
          moreTopicsUrl,
          newTopics
        } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if (newTopics && newTopics.length && _this.bulkSelectHelper?.bulkSelectEnabled) {
          _this.bulkSelectHelper.addTopics(newTopics);
        }
        if (moreTopicsUrl && $(window).height() >= $(document).height()) {
          _this.send("loadMore");
        }
      });
    }
  }
}, [["method", "_monitorTrackingState", [on("didInsertElement")]], ["method", "_removeTrackingStateChangeMonitor", [on("willDestroyElement")]], ["method", "_updateTitle", [observes("incomingCount")]]]));